import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import Button from 'discada/dist/Button'

import { getQuoteDirty, getQuoteValue } from 'selectors/quoteSelectors'
import { refreshPrograms } from 'actions/programActions'

import './Dirty.scss'

export function DirtyButtonPreso({
  className,
  size = 'medium',
  refreshPrograms,
  isLoading,
  noLabel,
  label,
}) {
  return (
    <Button
      className={c('dirty-button', className)}
      size={size}
      icon="sync-alt"
      onClick={refreshPrograms}
      success={!isLoading}
      loading={isLoading}
    >
      {!noLabel && label}
    </Button>
  )
}

export function DirtyMaskPreso({ className, vehicleId, quoteId, dirty, size }) {
  if (!dirty) return null

  return (
    <div className={c('dirty-mask', className)}>
      <DirtyButton
        vehicleId={vehicleId}
        quoteId={quoteId}
        dirty={dirty}
        size={size}
      />
    </div>
  )
}

function mapStateToProps(state, op) {
  let isLoading = getQuoteValue(
    state,
    op.vehicleId,
    op.quoteId,
    'gettingPrograms',
  )

  return {
    ...op,
    isLoading,
    label: op.label || 'Refresh Payments',
    dirty: getQuoteDirty(state, op.vehicleId, op.quoteId),
  }
}

export const DirtyButton = connect(
  mapStateToProps,
  { refreshPrograms },
)(DirtyButtonPreso)

export const DirtyMask = connect(mapStateToProps)(DirtyMaskPreso)
